import React from 'react';
import globalStyles from '../../styles';
import Panel from './Panel';
import ContributorList from '../../components/Panel/Contributors/ContributorList';
import {Link} from 'react-router';
import urlBase from '../../url-base';


  const styles = {
    tituloPagina: {
      fontSize: 20,
      fontWeight: 'bold'
    },
    breadcrumb: {
      fontSize: 12,
      float: 'right'
    }
  };

const ContributorsPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
           → 
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/contributors"}>
            Colaboradores
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Lista de
          <span style={styles.tituloPagina}> Colaboradores</span>
        </h3>

        <ContributorList />

      </div>
    </Panel>

  );
};

export default ContributorsPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/ContributorsPage.js
 **/